import React from 'react'

const DebugginDash = () => {
  return (
    <div>DebugginDash</div>
  )
}

export default DebugginDash